






































































































































import { Element, Product, SearchProductOptions, SearchElementOptions, ElementPostCopy, ProductPostCopyStructure, CvValue } from '@/models'
import { Component, Prop, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { ActionTypes } from '@/store/action-types'
import { MutationTypes } from '@/store/mutation-types'
import { CvValueUtils } from '@/utils/cv-value-utils'
import { CV_VALUE_ELEMENT_RELATION_TYPE } from '@/utils/constants'

@Component({})
export default class CopyElementModal extends Vue {
  @Prop({ required: false }) elementParentTarget: Element
  @Prop({ required: true }) productTarget: Product

  private productRelationSearch: Product | null = null
  private productRelationSearchArray: Product[] = []
  private elementRelationSearchArray: Element[] = []

  private elementRelationTo = ''
  private copyAllStructureFromProduct = false
  private copyOnlyStructure = false
  private elementRelationType = ''

  private cvElementRelation: CvValue[] = []

  private formOk(): boolean {
    if (this.copyAllStructureFromProduct) {
      return this.productRelationSearch !== null
    }
    return this.elementRelationTo !== ''
  }

  hideModal() {
    this.clearForm()
    this.$bvModal.hide('copyElementModal')
  }

  private clearForm() {
    this.productRelationSearch = null
    this.productRelationSearchArray = []
    this.elementRelationSearchArray = []
    this.elementRelationTo = ''
    this.copyAllStructureFromProduct = false
    this.copyOnlyStructure = false
    this.elementRelationType = ''
  }

  created() {
    this.loadElementRelationType()
  }

  private async loadElementRelationType() {
    this.cvElementRelation = await CvValueUtils.getCvValuesByType(CV_VALUE_ELEMENT_RELATION_TYPE)
  }

  private productRelationSelect() {
    // Clear element relation selected and search
    this.elementRelationSearchArray = []
    this.elementRelationTo = ''
  }

  copyElement() {
    if (this.copyAllStructureFromProduct) {
      this.copyAllStructure()
      return
    }

    const payload: ElementPostCopy = {
      elementIdToCopy: this.elementRelationTo,
      parentElementIdTarget: this.elementParentTarget != null ? this.elementParentTarget.id : '',
      productIdTarget: this.productTarget.id,
      copyOnlyStructure: this.copyOnlyStructure
    }
    if (this.elementRelationType !== '') {
      payload.elementRelationTypeWordkedAsFile = this.elementRelationType
    }
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.copyElement(payload, this.elementRelationTo)
      .then((element: Element) => {
        this.$emit('elementCopy', element)
        this.hideModal()
        this.clearForm()
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('copy_element_modal_component.title'),
          variant: 'success',
          message: this.$t('copy_element_modal_component.feedback.success') + ` ${element.name}`
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
      .catch((ex: any) => {
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('copy_element_modal_component.title'),
          variant: 'danger',
          message: `${ex.response.data.message}`
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
  }

  copyAllStructure() {
    if (!this.productRelationSearch) {
      return
    }
    const payload: ProductPostCopyStructure = {
      productCodeTarget: this.productTarget.code,
      productCodeOrigin: this.productRelationSearch.code
    }
    if (this.elementRelationType !== '') {
      payload.elementRelationTypeWordkedAsFile = this.elementRelationType
    }
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.copyAllStructure(payload)
      .then(() => {
        this.$emit('elementCopy')
        this.hideModal()
        this.clearForm()
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('copy_element_modal_component.title'),
          variant: 'success',
          message: this.$t('copy_element_modal_component.feedback.success_product_copy')
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
      .catch((ex: any) => {
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('copy_element_modal_component.title'),
          variant: 'danger',
          message: `${ex.response.data.message}`
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
  }

  private onSearchProduct(search: string, loading: any) {
    if (search.length > 2) {
      loading(true)
      this.searchProducts(search, loading)
    }
  }

  private searchProducts(search: string, loading: any) {
    const searchOptions: SearchProductOptions = {
      search: search,
      offset: 0,
      limit: 10,
      educationLevel1: null,
      manager: null,
      type: null,
      country: null,
      workType: null,
      subject: null,
      productionCampaign: null,
      editorialProject: null,
      relatedToDigital: null,
      editorialProjectYearStart: null,
      language: null,
      educationLevel2: null
    }

    ApiClient.searchProducts(searchOptions)
      .then(async(result) => {
        this.productRelationSearchArray = result.items
        loading(false)
      })
      .catch((e) => {
        loading(false)
        console.error('Error loading products', e)
      })
  }

  private onSearchElement(search: string, loading: any) {
    if (search.length > 2) {
      loading(true)
      this.searchElements(search, loading)
    }
  }

  private searchElements(search: string, loading: any) {
    if (!this.productRelationSearch) {
      return
    }
    const searchOptions: SearchElementOptions = {
      search: search,
      offset: 0,
      limit: 50,
      productId: parseInt(this.productRelationSearch.id),
      productCode: null
    }

    ApiClient.searchElements(searchOptions)
      .then(async(result) => {
        this.elementRelationSearchArray = result.items
        loading(false)
      })
      .catch((e) => {
        loading(false)
        console.error('Error loading elements', e)
      })
  }
}
